import { render } from "./EnvVars.vue?vue&type=template&id=1d03214e&scoped=true"
import script from "./EnvVars.vue?vue&type=script&lang=js"
export * from "./EnvVars.vue?vue&type=script&lang=js"

import "./EnvVars.vue?vue&type=style&index=0&id=1d03214e&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d03214e"]])

export default __exports__